module.exports = "<div class=\"spinner-container\" :class=\"classes\" v-if=\"!hide\">\n\t<div class=\"spinner\"></div>\n</div>\n"